const HEADER = {
	CONFIG_TITLE: "Configurações",
	COOKIES_OPTION: "Cookies",
	PROFILE_OPTION: "Perfil",
	LOGOUT_OPTION: "Sair"
};

export default HEADER;